import Button from 'primevue/button'

export default {
    name: 'LandingPage',
    data: () => {
        return {
            informations: [
                {
                    title: '¿Qué es SARA?',
                    content: '<span style="font-weight: bold; font-family: var(--font-inter-bold)">SARA</span> es la solución analítica que optimiza tu sistema antifraude actual, enfocando los esfuerzos en los puntos clave de prevención de fraude y operación interna.',
                    to: '/login'
                },
                {
                    title: '¿Cómo se compone SARA?',
                    content: 'Es un producto configurable totalmente SaaS dentro del cual se puede habilitar uno o varios de los módulos que lo componen. Puede ser implementado para cualquier cantidad de transacciones, una o varias líneas de negocio, uno o varios canales digitales.',
                    to: '/login'
                }
            ],
            complements: [
                [
                    {
                        title: 'Autenticación en el portal Web',
                        content: 'Podrás acceder al mundo analítico de SARA a través del portal Web con tus credenciales habilitadas',
                        to: '/portal/docs/quickguide/',
                        icon: 'icon-authentication',
                    },
                    {
                        title: 'Envío de los datos',
                        content: 'Por medio del envío de tus datos a SARA, podrás visualizar el análisis y desempeño de tu sistema antifraude para tener mayor claridad y perspectiva de tu solución.',
                        to: '/portal/docs/SFTPConnectionGuide/',
                        icon: 'icon-enviardata'
                    },
                ],
                [
                    {
                        title: 'Módulo Data Analysis',
                        content: 'Podrás explorar de forma interactiva tus datos actuales e históricos para tener un panorama claro del comportamiento del fraude y medir la cantidad de afectación que ha generado a lo largo del tiempo.',
                        to: '/portal/docs/modules/#modulo-data-analysis',
                        icon: 'icon-dataanalysis'
                    },
                    {
                        title: 'Módulo Performance',
                        content: 'Podrás entender la calidad del Score de Riesgo y el desempeño Operacional de tu servicio antifraude para identificar puntos específicos de mejora.',
                        to: '/portal/docs/modules/#modulo-performance',
                        icon: 'icon-performance'
                    },
                ],
                [
                    {
                        title: 'Módulo Benchmarking',
                        content: 'Entendiendo tu posición al comparar tus indicadores frente a la región, podrás reorientar tu estrategia en la lucha contra el fraude, protegiendo tu marca y diferenciándote de la competencia.',
                        to: '/portal/docs/modules/#modulo-benchmarking',
                        icon: 'icon-benchmarking'
                    },
                    {
                        title: 'Módulo Rule Optimizer',
                        content: 'Un mejor sistema de reglas significa una mayor detección con menor fricción sobre el cliente. SARA no solo te entrega paquetes de reglas óptimos, sino que también revela patrones ocultos de fraude.',
                        to: '/portal/docs/modules/#modulo-rule-optimizer',
                        icon: 'icon-ruleoptimizer'
                    }
                ]
            ]
        }
    },
    components: {Button},
    methods: {
        redirectTo(to) {
            window.location.href = to
        }
    }
}
